import React, { useEffect, useRef, useState } from 'react';
import { Download } from 'lucide-react';
import { pricingData } from '../data/mock';

const Pricing = () => {
  const imageRef = useRef(null);
  const [imageVisible, setImageVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setImageVisible(true);
          }
        });
      },
      { threshold: 0.3 }
    );

    if (imageRef.current) {
      observer.observe(imageRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = pricingData.brochureUrl;
    link.download = pricingData.brochureName;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <section className="pricing-section">
      <div className="container">
        <div className="pricing-grid">
          <div className="pricing-content">
            <h2 className="section-label">{pricingData.title}</h2>
            <p className="pricing-description">{pricingData.description}</p>
            <p className="pricing-approach">{pricingData.approach}</p>
            
            <div className="pricing-note-wrapper">
              <p className="pricing-note">{pricingData.note}</p>
              <button onClick={handleDownload} className="brochure-download-btn">
                <Download size={16} />
                <span>Download Brochure</span>
              </button>
            </div>
          </div>

          <div className="pricing-image-wrapper" ref={imageRef}>
            <img 
              src={pricingData.image}
              alt="Fashion consulting"
              className={`pricing-image ${imageVisible ? 'mobile-visible' : ''}`}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
